<div class="home-container">
  <nz-row>
    <nz-col [nzMd]="{ span: 24 }" [nzLg]="{ span: 8 }" *ngFor="let dash of dashboards">
      <div class="dashboard-container">
        <nz-card>
          <nz-statistic [nzTitle]="dash.code | SplitCamelCase" [nzValue]="dash.value">
          </nz-statistic>
        </nz-card>
      </div>
    </nz-col>
  </nz-row>
</div>
